
import React from 'react';
import './style.scss';

const Subtitle = ({ text }) => {
    if (!text) return null;

    return (
        <div className="subtitle-container">
            <div className="subtitle-text">
                {text}
            </div>
        </div>
    );
};

export default Subtitle;
